module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-2.3e3f5d89.mp3";